import { defineStore } from "pinia";
import Router from '../routes';
import Http from '../utils/http';
import Utils from '../utils/utils'
import i18n from '../localizations';
import { useRootStore } from "./root";

export const useSituationsStore = defineStore("situations", {
    state: () => ({
        situations: [],
        editedSituation: null
    }),

    actions: {
        addSituations(situations) {
            situations.forEach(situation => this.situations.push({
                id: situation['id'],
                name: situation['name'],
                template: situation['template']['key'],
                document: situation['document']['name']
            }));
        },

        clearSituations() {
            this.situations = [];
        },

        setEditedSituation(situation) {
            if (!situation) {
                this.editedSituation = situation
                return;
            }

            this.editedSituation = {
                id: situation['id'],
                name: situation['name'],
                templateId: situation['template_id'],
                documentId: situation['document_id'],
                situationParameters: situation['parameters'].map(parameter => ({
                    id: parameter['id'],
                    situationId: parameter['situation_id'],
                    parameterId: parameter['parameter_id'],
                    value: parameter['value']
                }))
            };
        },
        
        loadSituations() {
            Http.get('/api/situations')
                .then(response => {
                    const situations = response.data || [];

                    this.clearSituations();
                    this.addSituations(situations);
                })
                .catch(error => console.error(error));
        },

        loadSituation(situationId) {
            Http.get(`/api/situations/${situationId}`)
                .then(response => {
                    const situation = response.data;
                    this.setEditedSituation(situation);
                })
                .catch(error => console.error(error));
        },

        createSituation(situation) {
            const rootStore = useRootStore();
            
            Http.post('/api/situations', situation)
                .then(response => {
                    const situation = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.situation_successfully_created', { situationName: situation.name })
                    );
                    
                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/situations', null);
                })
                .catch(error => Utils.resolveValidationErrors(error));
        },

        updateSituation(situation) {
            const situationId = situation.id;

            if (situation.id !== undefined) {
                delete situation.id;
            }
            
            const rootStore = useRootStore();

            Http.put(`/api/situations/${situationId}`, situation)
                .then(response => {
                    const situation = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.situation_successfully_edited', { situationName: situation.name })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    Router.push('/situations', null);
                })
                .catch(error => Utils.resolveValidationErrors(error));
        },

        deleteSituation(situationId) {
            const rootStore = useRootStore();
            
            Http.delete(`/api/situations/${situationId}`)
                .then(response => {
                    const situation = response.data;
                    const notification = Utils.createNotification(
                        'success',
                        i18n.t('notifications.situation_successfully_deleted', { situationName: situation.name })
                    );

                    rootStore.clearNotifications();
                    rootStore.pushNotification(notification);

                    this.loadSituations();
                })
                .catch(error => console.error(error));
        },

        clearState() {
            this.$reset();
        },
    }
})